import '../../../App.css';
import Footer from '../Components/Static/Footer';
import HeaderBar from '../Components/Static/HeaderBar';
import {
  Typography,
  Container,
  Grid2,
  Box,
  Paper
} from '@mui/material';
import { } from "@mui/material";
import PeopleIcon from '@mui/icons-material/People';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PublicIcon from '@mui/icons-material/Public';
import HandshakeIcon from '@mui/icons-material/Handshake';


// Notice we are NOT importing from 'react-native' anymore
export default function AboutUs() {
  return (
    <>
    <HeaderBar isLoggedIn={false} />
    <Box
      sx={{
        flexGrow: 0, // Make the main content take available space
        paddingTop: 2,
        margin: 0,
        backgroundColor: 'transparent',
      }}
    >
      
      <div style={{
        padding:  '5px',
        paddingTop: '0px',
        backgroundColor: 'transparent',
        maxWidth: '900px',
        margin: '0 auto',
        textAlign: 'left'
      }}>

        {/* Container for grid items */}
        <Container>
          <Grid2 item xs={12} md={4}>
            <Paper sx={{ marginBottom: 1, padding: 2, height: "100%" }}>
              {/* Typography content */}
              <Typography variant="h4" sx={{ marginTop: 2 }} style={{ textAlign: 'center' }}>
                About RW
              </Typography>
            </Paper>
          </Grid2>
        </Container>

        <Container>
          <Box
            sx={{
              display: 'flex',
              gap: 1, // Space between items
              flexDirection: { xs: 'column', md: 'row' }, // Stack on small screens, side-by-side on larger screens
              marginBottom: 1
            }}
          >
            <Paper sx={{ flex: 1, padding: 2, height: "100px", display: 'flex', direction: 'row' }} style={{}}>
              <PeopleIcon sx={{color: '#2ECC71', display: 'flex', width: '40px', alignItems: 'center', height: 'auto', paddingRight: '10px'}} />
              <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', height: 'auto', textAlign: 'left' }}>
                Community Lead: The community determines the direction of Rōpū Whakatau, this is about leading together not alone.
              </Typography>
            </Paper>
            <Box sx={{ flex: 1 }}>
              <Paper sx={{ flex: 1, padding: 2, height: "100px", display: 'flex', direction: 'row' }} style={{}}>
                <PublicIcon sx={{color: '#2ECC71', display: 'flex', width: '40px', alignItems: 'center', height: 'auto', paddingRight: '10px'}}/>
                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', height: 'auto', textAlign: 'left' }}>
                   Unification: It's about working together not in small communities

                </Typography>
              </Paper>
            </Box>
          </Box>

        </Container>

        <Container sx={{marginTop: 1, marginBottom: 20}}>
          <Box
            sx={{
              display: 'flex',
              gap: 1, // Space between items
              flexDirection: { xs: 'column', md: 'row' }, // Stack on small screens, side-by-side on larger screens
            }}
          >
            <Paper sx={{ flex: 1, padding: 2, height: "100px", display: 'flex', direction: 'row' }} style={{}}>
              <FavoriteIcon sx={{color: '#2ECC71', display: 'flex', width: '40px', alignItems: 'center', height: 'auto', paddingRight: '10px'}} /> 
              <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', height: 'auto', textAlign: 'left' }}>
              Relationships Matter: Building and maintaining relationships is important. Rōpū Whakatau aims to let you connect with and maintain those relationships
              regardless of location
              </Typography>
            </Paper>
            <Box sx={{ flex: 1 }}>
              <Paper sx={{ flex: 1, padding: 2, height: "100px", display: 'flex', direction: 'row' }} style={{}}>
                <HandshakeIcon sx={{color: '#2ECC71', display: 'flex', width: '40px', alignItems: 'center', height: 'auto', paddingRight: '10px'}} /> 
                <Typography variant="body1" sx={{ display: 'flex', alignItems: 'center', height: 'auto', textAlign: 'left' }}>
                Trust: Building relationships is important but also gaining and maintaining trust by fostering a positive environment.
                </Typography>
              </Paper>
            </Box>
          </Box>
        </Container>

      </div>
      <div style={{position: 'fixed', width: "100%", left: 0, bottom: 0}} >
      <Footer/>
      </div>
    </Box>
    </>
  );
}